import { render } from "./HomeView.vue?vue&type=template&id=6c12c3f2&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=6c12c3f2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c12c3f2"]])

export default __exports__